import styled from 'styled-components';

import { Portal } from '@dreryk/react-components';

export const StyledExtendedDosageHeaderActions = styled(Portal.Container)`
   display: flex;
   gap: 16px;
   font-weight: normal;
`;

StyledExtendedDosageHeaderActions.displayName = 'StyledExtendedDosageHeaderActions';
